/* Uses the same key and three-item limit as the existing Scent Guide shortlist. */
(() => {
  if (customElements.get('aether-shortlist-product')) return;
  customElements.define('aether-shortlist-product', class extends HTMLElement {
    connectedCallback() {
      this.controller?.abort();
      this.controller = new AbortController();
      this.button = this.querySelector('[data-asp-button]');
      this.label = this.querySelector('[data-asp-label]');
      this.status = this.querySelector('[data-asp-status]');
      try { this.allowed = new Set(JSON.parse(this.querySelector('[data-asp-handles]').textContent)); } catch (_) { return; }
      if (!this.button || !this.label || !this.status || !this.allowed.has(this.dataset.handle)) return;
      this.key = 'aether:shortlist:v1';
      this.button.hidden = false;
      const refresh = () => {
        try {
          const value = JSON.parse(localStorage.getItem(this.key) || '[]');
          this.selected = Array.isArray(value) ? [...new Set(value.filter((handle) => typeof handle === 'string' && this.allowed.has(handle)))].slice(0, 3) : [];
          if (this.storageFailed) this.status.textContent = '';
          this.storageFailed = false;
          this.button.disabled = false; this.render();
          return true;
        } catch (_) { this.unavailable(); return false; }
      };
      this.button.addEventListener('click', () => {
        if (!refresh()) return;
        const handle = this.dataset.handle;
        const saved = this.selected.includes(handle);
        if (!saved && this.selected.length >= 3) {
          this.status.textContent = 'Your comparison has three fragrances. Remove one in the comparison before adding another.';
          return;
        }
        const next = saved ? this.selected.filter((item) => item !== handle) : [...this.selected, handle];
        try {
          if (next.length) localStorage.setItem(this.key, JSON.stringify(next));
          else localStorage.removeItem(this.key);
        } catch (_) { this.unavailable(); return; }
        this.selected = next; this.render();
        this.status.textContent = this.dataset.name + (saved ? ' removed from comparison.' : ' saved to comparison.');
        window.dispatchEvent(new Event('aether:shortlist-updated'));
      }, { signal: this.controller.signal });
      window.addEventListener('storage', (event) => { if (event.key === this.key || event.key === null) refresh(); }, { signal: this.controller.signal });
      window.addEventListener('aether:shortlist-updated', refresh, { signal: this.controller.signal });
      window.addEventListener('pageshow', refresh, { signal: this.controller.signal });
      refresh();
    }
    disconnectedCallback() { this.controller?.abort(); }
    render() {
      const saved = this.selected.includes(this.dataset.handle);
      this.button.setAttribute('aria-pressed', String(saved));
      this.label.textContent = saved ? 'Saved to comparison' : 'Save to comparison';
    }
    unavailable() {
      this.storageFailed = true;
      this.button.disabled = true;
      this.status.textContent = 'Saving is unavailable in this browser. Open the comparison to choose fragrances there.';
    }
  });
})();
